module.exports = __webpack_public_path__ + "img/style_9_en.42ba6025.jpeg";